import React, { useState, useEffect } from 'react';
import './Blogs.css';

const Blogs = ({ goToHome }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 3;

  const blogs = [ { id: 1, title: "Cómo mejorar la calidad del suelo orgánicamente", date: "15 Marzo 2024", author: "Dr. Juan Pérez", category: "Suelos", image: "https://images.unsplash.com/photo-1585336261022-680e295ce3fe?w=800", excerpt: "Descubre técnicas naturales para enriquecer tu suelo sin químicos dañinos...", content: "Contenido completo del blog 1..." }, { id: 2, title: "Beneficios de los fertilizantes orgánicos", date: "10 Marzo 2024", author: "Ing. María Gómez", category: "Fertilizantes", image: "https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=800", excerpt: "Los fertilizantes orgánicos mejoran la producción y cuidan el medio ambiente...", content: "Contenido completo del blog 2..." }, { id: 3, title: "Agricultura sostenible en el siglo XXI", date: "5 Marzo 2024", author: "Lic. Carlos López", category: "Sostenibilidad", image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=800", excerpt: "Prácticas agrícolas que garantizan el futuro de nuestro planeta...", content: "Contenido completo del blog 3..." }, { id: 4, title: "Control de plagas sin químicos", date: "28 Febrero 2024", author: "Bióloga Ana Martínez", category: "Plagas", image: "https://images.unsplash.com/photo-1574943320219-553eb213f972?w=800", excerpt: "Métodos naturales para mantener tus cultivos libres de plagas...", content: "Contenido completo del blog 4..." }, { id: 5, title: "Cosechas más productivas con abonos verdes", date: "20 Febrero 2024", author: "Ing. Roberto Sánchez", category: "Abonos", image: "https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=800", excerpt: "Los abonos verdes aumentan la fertilidad y estructura del suelo...", content: "Contenido completo del blog 5..." }, { id: 6, title: "Rotación de cultivos: guía completa", date: "15 Febrero 2024", author: "Dr. Luis Ramírez", category: "Técnicas", image: "https://images.unsplash.com/photo-1592982537447-6f2a6a0c7e1b?w=800", excerpt: "La rotación de cultivos previene enfermedades y mejora la producción...", content: "Contenido completo del blog 6..." }, { id: 7, title: "Compostaje casero para principiantes", date: "10 Febrero 2024", author: "María Fernández", category: "Compostaje", image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=800", excerpt: "Aprende a hacer tu propio compost con residuos orgánicos...", content: "Contenido completo del blog 7..." }, { id: 8, title: "Tecnología e innovación agrícola", date: "5 Febrero 2024", author: "Ing. David Torres", category: "Tecnología", image: "https://images.unsplash.com/photo-1586771107445-d3ca888129ff?w=800", excerpt: "Las nuevas tecnologías que están revolucionando el campo...", content: "Contenido completo del blog 8..." }, { id: 9, title: "Cultivos hidropónicos en casa", date: "30 Enero 2024", author: "Arq. Laura Díaz", category: "Hidroponía", image: "https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=800", excerpt: "Cómo cultivar tus propios alimentos sin tierra en espacios pequeños...", content: "Contenido completo del blog 9..." }, { id: 10, title: "Fertilización foliar: qué es y cómo hacerla", date: "25 Enero 2024", author: "Dr. Jorge Herrera", category: "Fertilización", image: "https://images.unsplash.com/photo-1585336261022-680e295ce3fe?w=800", excerpt: "La fertilización foliar nutre directamente las hojas de tus plantas...", content: "Contenido completo del blog 10..." } ];

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  return (
    <div className="blogs-container">
      <button onClick={() => goToHome()} className="back-home-btn">
        ← Volver al inicio
      </button>
      
      <div className="blogs-header">
        <h1 className="blogs-title">BLOGS AGRÍCOLAS</h1>
        <p className="blogs-subtitle">
          Consejos, noticias y tendencias para una agricultura sostenible y productiva
        </p>
      </div>

      <div className="blogs-grid">
        {currentBlogs.map((blog) => (
          <article key={blog.id} className="blog-card">
            <div className="blog-card-image">
              <img src={blog.image} alt={blog.title} />
              <span className="blog-category">{blog.category}</span>
            </div>
            <div className="blog-card-content">
              <div className="blog-meta">
                <span className="blog-date">📅 {blog.date}</span>
                <span className="blog-author">✍️ {blog.author}</span>
              </div>
              <h2 className="blog-card-title">{blog.title}</h2>
              <p className="blog-card-excerpt">{blog.excerpt}</p>
              <button className="blog-read-more">Leer más →</button>
            </div>
          </article>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="page-btn"
          >
            ← Anterior
          </button>
          
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => paginate(index + 1)}
              className={`page-btn ${currentPage === index + 1 ? 'active' : ''}`}
            >
              {index + 1}
            </button>
          ))}
          
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="page-btn"
          >
            Siguiente →
          </button>
        </div>
      )}
    </div>
  );
};

export default Blogs;